import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    FormControl,
    TextField,
    Paper,
    Button,
    IconButton,
    Tooltip,
    Stack,
    useTheme,
    LinearProgress,
    Select,
    MenuItem,
    InputLabel,
    Alert,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
    // DataGrid,
    GridToolbarContainer,
    // GridToolbarColumnsButton,
    // GridToolbarFilterButton,
    // GridToolbarExport,
    // GridToolbarDensitySelector,
    GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import { Formik } from "formik";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { DataGrid } from "@mui/x-data-grid";
import { useProSidebar } from "react-pro-sidebar";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { tokens } from "../../../Theme";
import store from "../../../index";
import { LoadingButton } from "@mui/lab";
import { useDispatch } from "react-redux";
import { fetchExplorelitview } from "../../../store/reducers/Explorelitviewapireducer";
import FileListPopup from "../../../ui-components/FIleViewDialog";
import FileUploadIconButton from "../../../ui-components/FileUploadButton";
import { attachmentPost } from "../../../store/reducers/LoginReducer";
import GradingIcon from '@mui/icons-material/Grading';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import {
    fetchApidata,
    explorePostData,
    postData,
    getFetchData,
    requestMail,

} from "../../../store/reducers/Formapireducer";
import { toast } from "react-hot-toast";
import CryptoJS from 'crypto-js';
import { formGap } from "../../../ui-components/global/utils";
import { leaveAppoval, mailNotify } from "../../../store/reducers/Listviewapireducer";
import { CheckinAutocomplete, Productautocomplete } from "../../../ui-components/global/Autocomplete";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import axios from "axios";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
// import ErrorMsgData from "../../Security/validationMsg.json"
import * as Yup from "yup";
import { Mode } from "@mui/icons-material";

const KEY = CryptoJS.enc.Utf8.parse('1234567890123456'); // 16-byte key
const IV = CryptoJS.enc.Utf8.parse('1234567890123456');  // 16-byte IV


export function encryptDataUrlSafe(plainText) {
    const encrypted = CryptoJS.AES.encrypt(plainText, KEY, {
        iv: IV,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    }).toString(); // Standard base64

    // Convert to URL-safe base64
    return encrypted.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function decryptData(encryptedBase64) {
    const decrypted = CryptoJS.AES.decrypt(
        { ciphertext: CryptoJS.enc.Base64.parse(encryptedBase64) },
        KEY,
        {
            iv: IV,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        }
    );

    return decrypted.toString(CryptoJS.enc.Utf8); // Original string
}
const Editpermission = ({ appId, empId }) => {
    const isNonMobile = useMediaQuery("(min-width:600px)");
    const navigate = useNavigate();
    const params = useParams();
    const location = useLocation();
    const mode = params.Mode;
    console.log(mode, "Mode");
    const dispatch = useDispatch();
    var CompanyID = sessionStorage.getItem("companyId");
    const [open, setOpen] = useState(false);
    var recID = params.id;
    var accessID = params.accessID;
    const { toggleSidebar, broken, rtl } = useProSidebar();
    const listViewData = useSelector((state) => state.listviewApi.rowData);
    const listViewColumn = useSelector((state) => state.listviewApi.columnData);
    const [showtable, setShowtable] = useState(false);
    const getLoading = useSelector((state) => state.formApi.getLoading);
    const data = useSelector((state) => state.formApi.Data);
    const isLoading = useSelector((state) => state.formApi.loading);
    const [pageSize, setPageSize] = useState(10);
    const [rowCount, setRowCount] = useState(0);
    const [show, setScreen] = React.useState("0");
    const [files, setFiles] = useState([]);
    const [showImage, setShowImage] = useState(params.Mode == "IM" ? true : false)
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const rowSx = { height: 36, '& td, & th': { py: 0.5 } };
    const EMPID = sessionStorage.getItem("EmpId");
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    // let validationSchemaFields = {
    //     permissiondate: Yup.string().required(ErrorMsgData.Permission.permissiondate),
    //     reason: Yup.string().required(ErrorMsgData.Permission.reason),
    //     fromtime: Yup.string().required(ErrorMsgData.Permission.fromtime),
    //     totime: Yup.string().required(ErrorMsgData.Permission.totime),
    // };

    // if (mode === "M") {
    //     validationSchemaFields.managerComments = Yup.string().required(ErrorMsgData.Permission.managerComments);
    // }
    const [errorMsgData, setErrorMsgData] = useState(null);
    const [validationSchema, setValidationSchema] = useState(null);

    useEffect(() => {
        fetch(process.env.PUBLIC_URL + "/validationcms.json")
            .then((res) => {
                if (!res.ok) throw new Error("Failed to fetch validationcms.json");
                return res.json();
            })
            .then((data) => {
                setErrorMsgData(data);
                const schema = Yup.object().shape({

                    permissiondate: Yup.string().required(data.Permission.permissiondate),
                    reason: Yup.string().trim().required(data.Permission.reason),
                    fromtime: Yup.string().required(data.Permission.fromtime),
                    totime: Yup.string().required(data.Permission.totime),
                    // managerComments: Yup.string().required(data.Permission.managerComments),
                    managerComments:
                        mode === "M" ||
                            (mode === "E" && (data.Status === "RJ" || data.Status === "QR"))
                            ? Yup.string().required(
                                data?.Permission?.managerComments || "Manager Comments is required"
                            )
                            : Yup.string().notRequired(),
                    Status: mode === "M" ? Yup.string().required(data.Permission.Status) : Yup.string().notRequired(),


                });

                setValidationSchema(schema);
            })
            .catch((err) => console.error("Error loading validationcms.json:", err));
    }, [mode, data.Status]);
    useEffect(() => {
        dispatch(getFetchData({ accessID, get: "get", recID })).then((res) => {
            console.log(res, "response");
            console.log(res.payload.Data.EmployeeID, "response");
            var url = store.getState().globalurl.empGetAttachmentUrl;
            axios
                .get(url, {
                    params: {
                        empId: res.payload.Data.EmployeeID,
                        appId: recID
                    }
                })
                .then((response) => {
                    setFiles(response.data);
                })
                .catch((err) => {
                    setError('Failed to fetch attachments.');
                    console.error(err);
                })
                .finally(() => setLoading(false));

        })
    }, []);


    const [proName, setProName] = useState(null);

    const currentDate = new Date().toISOString().split('T')[0];
    console.log(data.ProjectID, "--data.ProjectID");

    const InitialValue = {
        applieddate: mode == "A" ? currentDate : data.AppliedDate,
        permissiondate: data.PermissionDate,
        fromtime: data.FromTime,
        totime: data.ToTime,
        location: data.Location,
        reason: data.Reasons,
        Status: data.Status,
        managerComments: mode == "M" ? data.ManagerComments : "",


    };
    const FNsave = async (values, resetForm, del) => {
        setLoading(true);
        // console.log(funMode, "+  funMode");
        console.log(data, "--data.ProjectID");
        let action =
            mode === "A" && !del
                ? "insert"
                : mode === "E" && del
                    ? "harddelete"
                    : "update";
        const idata = {
            //RecordID:leaveData.recordID,
            RecordID: data.RecordID,
            AppliedDate: values.applieddate,
            PermissionDate: values.permissiondate,
            ToTime: values.totime,
            FromTime: values.fromtime,
            Location: values.location,
            EmployeeID: mode == "M" ? params.parentID : EMPID,
            ManagerComments: mode == "M" ? values.managerComments : "",
            Reasons: values.reason,
            Status: mode == "A" ? "AL" : mode == "E" && values.Status == "QR" ? "AL" : values.Status, Status: mode == "A" ? "AL" : mode == "E" && values.Status == "QR" ? "AL" : values.Status,
            Source: "Self",
            // ManagerComments:"",
            CompanyID

        };
        const response = await dispatch(
            postData({ accessID: "TR266", action, idata })
        );
        if (response.payload.Status == "Y") {

            setLoading(false);
            if (mode == "A") {
                dispatch(
                    requestMail({
                        EmployeeID: EMPID,
                        Type: "P",
                        RecordID: response.payload.PermissionRecid,
                        encryptData: encryptDataUrlSafe(response.payload.PermissionRecid)
                    })
                );

                dispatch(
                    leaveAppoval({
                        data: {
                            RecordID: response.payload.PermissionRecid,
                            ManagerID: "",
                            EmployeeID: EMPID,
                            Type: "P",
                            Status: "AL",
                            Reason: values.reason,
                        },
                    })
                );
            }

            if (mode == "M") {
                dispatch(
                    leaveAppoval({
                        data: {
                            RecordID: recID,
                            ManagerID: EMPID,
                            EmployeeID: params.parentID,
                            Type: "P",
                            Status: values.Status == "AP" ? "Y" : values.Status == "QR" ? values.Status : "N",
                            Reason: "",
                            Source: "M"
                        },
                    })
                );
                dispatch(mailNotify({

                    RecordID: recID,
                    ManagerID: EMPID,
                    EmployeeID: params.parentID,
                    Type: "P",
                    Status: values.Status == "AP" ? "Y" : values.Status == "QR" ? values.Status : "N",
                    Reason: "",
                    Source: "M"

                }));
            }
            // dispatch(fetchExplorelitview("TR216", "OT",`EmployeeID='${EMPID}'`, ""));
            toast.success(response.payload.Msg);
            navigate(-1);
            // selectCellRowData({ rowData: {}, mode: "A", field: "" });
            resetForm();
        }
        else if (response.payload.Status == "N") {
            toast.error(response.payload.Msg);

            console.log(values, "--values");

        }
        else {
            setLoading(false);
            toast.error(response.payload.Msg);
        }
    };

    function LeaveTool() {
        return (
            <GridToolbarContainer
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                }}
            >
                <Box sx={{ display: "flex", flexDirection: "row" }}>
                    {/* <Typography>{(show == "2" ? "List of Leave" :show == "6" ? "List of OT" : (show == "1" ? "List of Allowance" :"List of Deductions"))}</Typography> */}

                    <Typography variant="h5">List of OT{`(${rowCount}))`}</Typography>
                </Box>

                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                    }}
                >
                    <GridToolbarQuickFilter />
                    <Tooltip title="ADD">
                        <IconButton type="reset">
                            <AddOutlinedIcon />
                        </IconButton>
                    </Tooltip>
                </Box>
            </GridToolbarContainer>
        );
    }
    const explorelistViewData = useSelector(
        (state) => state.exploreApi.explorerowData
    );
    const explorelistViewColumn = useSelector(
        (state) => state.exploreApi.explorecolumnData
    );
    const exploreLoading = useSelector((state) => state.exploreApi.loading);
    const screenChange = (event) => {
        setScreen(event.target.value);
    };
    const VISIBLE_FIELDS = [
        "SLNO",
        "OtDate",
        "NumberOfHours",
        "Status",
        "action",
    ];
    const [funMode, setFunMode] = useState("A");
    const columns = React.useMemo(
        () =>
            explorelistViewColumn
                ? explorelistViewColumn.filter((column) =>
                    VISIBLE_FIELDS.includes(column.field)
                )
                : [],
        [explorelistViewColumn]
    );

    const fnLogOut = (props) => {
        Swal.fire({
            title: errorMsgData.Warningmsg[props],
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: props,
        }).then((result) => {
            if (result.isConfirmed) {
                if (props === "Logout") navigate("/");
                if (props === "Close") navigate(-1);
            }
        });
    };
    async function fileUpload(file, EMPID, action, id, purpose) {
        console.log("🚀 ~ fileUpload ~ file:", file)
        const formData = new FormData();
        formData.append('file', file);
        formData.append('empId', data.EmployeeID);
        formData.append('appId', data.RecordID);
        formData.append('type', "P");
        formData.append('source', "Self");
        formData.append("action", action);
        formData.append("id", id);
        formData.append("purpose", purpose);
        console.log("📦 FormData contents:");
        for (let [key, value] of formData.entries()) {
            console.log(`${key}:`, value);
        }

        const respose = await dispatch(attachmentPost({ data: formData }))

        if (respose.payload.success) {
            toast.success(respose.payload.message)
            //setShowtable(true);
            var url = store.getState().globalurl.empGetAttachmentUrl;
            axios
                .get(url, {
                    params: {
                        empId: data.EmployeeID,
                        appId: data.RecordID,

                    }
                })
                .then((response) => {
                    setFiles(response.data);
                })
                .catch((err) => {
                    setError('Failed to fetch attachments.');
                    console.error(err);
                })
                .finally(() => setLoading(false));
        }
        else {
            toast.success(respose.payload.message)
        }

        console.log("🚀 ~ fileUpload ~ respose:", respose)
    }
    return (
        <React.Fragment>
            {getLoading && <LinearProgress />}
            <Paper elevation={3} sx={{ margin: "0px 10px", background: "#F2F0F0", height: "40px" }}>
                <Box display="flex" justifyContent="space-between" >
                    <Box display="flex" borderRadius="3px" alignItems="center">
                        {broken && !rtl && (
                            <IconButton onClick={() => toggleSidebar()}>
                                <MenuOutlinedIcon />
                            </IconButton>
                        )}
                        <Typography variant="h3" sx={{ marginLeft: "10px", fontSize: "19px",color: "#0000D1" }}>Permission</Typography>
                    </Box>
                    <Box display="flex">
                        <Tooltip title="Close">
                            <IconButton onClick={() => fnLogOut("Close")} color="error">
                                <ResetTvIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Logout">
                            <IconButton color="error" onClick={() => fnLogOut("Logout")}>
                                <LogoutOutlinedIcon />
                            </IconButton>
                        </Tooltip>

                    </Box>

                </Box>
            </Paper>

            {!getLoading ? (


                <Paper elevation={3} sx={{ margin: "10px" }}>
                    {mode === "IM" && (
                        <Box
                            display="flex"
                            padding={1}
                            justifyContent="flex-end"
                            mt="2px"
                            gridColumn="span 4"
                            gap={2}
                            //marginBottom={-5}
                            mb={{ xs: -3, sm: -5, md: -5 }}
                        >
                            <IconButton
                                onClick={() => setShowImage(prev => !prev)}
                            >
                                <ArrowDownwardIcon sx={{ color: "blue" }} />
                            </IconButton>
                        </Box>)}


                    <Formik
                        initialValues={InitialValue}
                        enableReinitialize={true}
                        onSubmit={(values, { resetForm }) => {
                            setTimeout(() => {
                                FNsave(values, resetForm, false);

                            }, 100);
                        }}
                        validationSchema={validationSchema}

                    >
                        {({
                            errors,
                            touched,
                            handleBlur,
                            handleChange,
                            isSubmitting,
                            values,
                            handleSubmit,
                            resetForm,
                            setFieldValue
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Box
                                    display="grid"
                                    gap={formGap}
                                    padding={1}
                                    gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                                    sx={{
                                        "& > div": {
                                            gridColumn: isNonMobile ? undefined : "span 4",
                                        },
                                    }}
                                >
                                    <FormControl sx={{ gridColumn: "span 2", gap: "15px" }}>

                                        <TextField
                                            name="applieddate"
                                            type="date"
                                            id="applieddate"
                                            label="Applied Date"
                                            variant="standard"
                                            focused
                                            inputFormat="YYYY-MM-DD"
                                            value={values.applieddate}
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            error={!!touched.applieddate && !!errors.applieddate}
                                            helperText={touched.applieddate && errors.applieddate}
                                            sx={{ gridColumn: "span 2" }}
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{
                                                max: new Date().toISOString().split("T")[0],
                                                readOnly: true,
                                            }}
                                            disabled={mode === "M" || (mode == "E" && values.Status != "AL" && values.Status != "RC")}
                                        />

                                        <TextField
                                            name="permissiondate"
                                            type="date"
                                            id="permissiondate"
                                            label={
                                                <>
                                                    Permission Date<span style={{ color: "red", fontSize: "20px" }}> * </span>
                                                </>
                                            }
                                            InputLabelProps={{ shrink: true }}
                                            variant="standard"
                                            focused
                                            inputFormat="YYYY-MM-DD"
                                            value={values.permissiondate}
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            error={!!touched.permissiondate && !!errors.permissiondate}
                                            helperText={touched.permissiondate && errors.permissiondate}
                                            sx={{ gridColumn: "span 2" }}
                                            // inputProps={{
                                            //     max: new Date().toISOString().split("T")[0],
                                            //     readOnly: true,
                                            // }}
                                            // required
                                            disabled={mode === "M" || (mode == "E" && values.Status != "AL" && values.Status != "RC")}
                                        />
                                        {!showImage ? <React.Fragment>

                                            <TextField
                                                disabled={
                                                    mode === "M" || (
                                                        mode == "E" &&
                                                        values.Status != "AL" &&
                                                        values.Status != "QR"
                                                    )
                                                }
                                                label={
                                                    <>
                                                        From Time<span style={{ color: "red", fontSize: "20px" }}> * </span>
                                                    </>
                                                }
                                                fullWidth
                                                variant="standard"
                                                type="time"
                                                id="fromtime"
                                                name="fromtime"
                                                inputFormat="HH:mm:aa"
                                                value={values.fromtime}
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                error={!!touched.fromtime && !!errors.fromtime}
                                                helperText={touched.fromtime && errors.fromtime}


                                                focused

                                            // required
                                            // inputProps={{ maxLength:20}}
                                            />

                                            <TextField
                                                disabled={
                                                    mode === "M" || (
                                                    mode == "E" &&
                                                    values.Status != "AL" &&
                                                    values.Status != "QR"
                                                    )
                                                }
                                                fullWidth
                                                variant="standard"
                                                type="time"
                                                id="totime"
                                                name="totime"
                                                inputFormat="HH:mm:aa"
                                                value={values.totime}
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                label={
                                                    <>
                                                        To Time<span style={{ color: "red", fontSize: "20px" }}> * </span>
                                                    </>
                                                }
                                                focused
                                                error={!!touched.totime && !!errors.totime}
                                                helperText={touched.totime && errors.totime}
                                            // required
                                            // inputProps={{ readOnly: true }}
                                            />

                                            <TextField
                                                //disabled={data.TaskSource === "Manager" || data.Status === "Approved"}
                                                disabled={
                                                    mode === "M" || (
                                                    mode == "E" &&
                                                    values.Status != "AL" &&
                                                    values.Status != "QR"
                                                    )
                                                }
                                                name="location"
                                                type="text"
                                                id="location"
                                                label="Location"
                                                variant="standard"
                                                focused
                                                value={values.location}
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                sx={{ gridColumn: "span 2" }}
                                            //required
                                            />
                                            <TextField
                                                disabled={mode === "M" || (mode == "E" && values.Status != "AL" && values.Status != "QR" && values.Status != "RC")}

                                                // disabled={mode == "E" && values.Status != "AL"}
                                                fullWidth
                                                variant="outlined"
                                                type="text"
                                                label={
                                                    <>
                                                        Reason<span style={{ color: "red", fontSize: "20px" }}> * </span>
                                                    </>
                                                }
                                                // required
                                                multiline
                                                rows={6}
                                                value={values.reason}
                                                id="reason"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                name="reason"
                                                error={!!touched.reason && !!errors.reason}
                                                helperText={touched.reason && errors.reason}
                                                sx={{
                                                    gridColumn: "span 2",
                                                    backgroundColor: "",
                                                    "& .MuiFilledInput-root": {
                                                        backgroundColor: "",
                                                    },
                                                }}
                                                focused
                                            />
                                            {mode == "M" || (mode == "E" && (values.Status == "RJ" || values.Status == "RC")) ? (
                                                <TextField
                                                    disabled={mode == "E" && values.Status != "AL"}

                                                    fullWidth
                                                    variant="outlined"
                                                    type="text"
                                                    // label="Manager Comments"
                                                      label={
                                                    <>
                                                        Manager Comments<span style={{ color: "red", fontSize: "20px" }}> * </span>
                                                    </>
                                                }
                                                    multiline
                                                    rows={6}
                                                    value={values.managerComments}
                                                    id="managerComments"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    error={!!touched.managerComments && !!errors.managerComments}
                                                    helperText={touched.managerComments && errors.managerComments}
                                                    name="managerComments"
                                                    sx={{
                                                        gridColumn: "span 2",
                                                    }}
                                                    focused
                                                    onInvalid={(e) => {
                                                        e.target.setCustomValidity(data.Permission.managerComments);
                                                    }}
                                                    onInput={(e) => {


                                                        e.target.setCustomValidity("");
                                                    }}
                                                />
                                            ) : false}
                                            {mode == "M" && (
                                                <TextField
                                                    select
                                                    label="Status"
                                                    id="Status"
                                                    name="Status"
                                                    value={values.Status}
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    required
                                                    focused
                                                    variant="standard"
                                                >
                                                    {mode != "M" && <MenuItem value="AL">Applied</MenuItem>}
                                                    <MenuItem disabled={mode != "M"} value="AP">
                                                        Approved
                                                    </MenuItem>
                                                    <MenuItem disabled={mode != "M"} value="RJ">
                                                        Rejected
                                                    </MenuItem>
                                                    {mode == "M" && (
                                                        <MenuItem value="QR">Query</MenuItem>
                                                    )}
                                                </TextField>
                                            )}

                                            {mode == "E" && values.Status == "AP" && (
                                                <Alert variant="filled" sx={{ mt: 1 }} severity="success">
                                                    Your Permission Request has been Approved.
                                                </Alert>
                                            )}
                                            {mode == "E" && values.Status == "RJ" && (
                                                <Alert variant="filled" sx={{ mt: 1 }} severity="error">
                                                    Your Permission Request has been Rejected.
                                                </Alert>
                                            )}
                                            {mode == "E" && values.Status == "QR" && (
                                                <Alert variant="filled" sx={{ mt: 1 }} severity="warning">
                                                    Your Permission Request has been Queried.
                                                </Alert>
                                            )}

                                        </React.Fragment> : false}

                                    </FormControl>

                                    {/* {mode === "IM" && (
                                            <ArrowDownwardIcon
                                                color="info"
                                                onClick={() => setShowImage((prev) => !prev)}
                                                sx={{ cursor: "pointer" }}
                                            />
                                        )} */}


                                    <Box
                                        display="flex"
                                        padding={1}
                                        justifyContent="flex-end"
                                        mt="2px"
                                        gridColumn="span 4"
                                        gap={2}
                                    >
                                        {/* {mode === "E" ? (
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <FileUploadIconButton onFileSelect={fileUpload} />
                                            </Box>
                                        ) : null} */}
                                        {mode == "IM" && (
                                            <>
                                                <TextField
                                                    name="purpose"
                                                    type="text"
                                                    id="purpose"
                                                    label="Purpose"
                                                    variant="standard"
                                                    focused
                                                    value={values.purpose}
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    error={!!touched.purpose && !!errors.purpose}
                                                    helperText={touched.purpose && errors.purpose}
                                                    sx={{ gridColumn: "span 2", height: "20px" }}
                                                    InputLabelProps={{ shrink: true }}

                                                />

                                                <Box display="flex" alignItems="center" gap={1}>
                                                    <FileUploadIconButton onFileSelect={(file) => {
                                                        fileUpload(
                                                            file,
                                                            data.EmployeeID,
                                                            "upload",
                                                            "",
                                                            values.purpose
                                                        )
                                                        setFieldValue("purpose", "");
                                                    }}
                                                    />
                                                </Box>
                                            </>
                                        )}
                                        {mode != "M" && (values.Status == "AL" || values.Status == "RC" || mode == "A") && (
                                            <LoadingButton
                                                disabled={mode == "IM"}
                                                color="secondary"
                                                variant="contained"
                                                type="submit"
                                                loading={isLoading}
                                            >
                                                Save
                                            </LoadingButton>
                                        )}
                                        {mode == "M" && (

                                            <LoadingButton
                                                disabled={mode == "IM"}
                                                color="secondary"
                                                variant="contained"
                                                type="submit"
                                                loading={isLoading}
                                            >
                                                Save
                                            </LoadingButton>
                                        )}
                                        {mode != "M" && values.Status == "AL" && (
                                            <Button
                                                color="error"
                                                variant="contained"
                                                disabled={mode == "IM"}
                                                onClick={() => {
                                                    Swal.fire({
                                                        title: errorMsgData.Warningmsg.Delete,
                                                        icon: "warning",
                                                        showCancelButton: true,
                                                        confirmButtonColor: "#3085d6",
                                                        cancelButtonColor: "#d33",
                                                        confirmButtonText: "Confirm",
                                                    }).then((result) => {
                                                        if (result.isConfirmed) {
                                                            FNsave(values, resetForm, "harddelete");
                                                            // navigate(-1);
                                                        } else {
                                                            return;
                                                        }
                                                    });
                                                }}
                                            >
                                                Delete
                                            </Button>
                                        )}
                                        {mode == "M" && (
                                            <Button
                                                color="error"
                                                variant="contained"
                                                onClick={() => {
                                                    Swal.fire({
                                                        title: errorMsgData.Warningmsg.Delete,
                                                        icon: "warning",
                                                        showCancelButton: true,
                                                        confirmButtonColor: "#3085d6",
                                                        cancelButtonColor: "#d33",
                                                        confirmButtonText: "Confirm",
                                                    }).then((result) => {
                                                        if (result.isConfirmed) {
                                                            FNsave(values, resetForm, "harddelete");
                                                            // navigate(-1);
                                                        } else {
                                                            return;
                                                        }
                                                    });
                                                }}
                                            >
                                                Delete
                                            </Button>
                                        )}

                                        <Button
                                            type="reset"
                                            color="warning"
                                            variant="contained"
                                            onClick={() => {
                                                navigate(-1);
                                            }}
                                        >
                                            Cancel
                                        </Button>
                                        <FileListPopup
                                            open={open}
                                            onClose={() => setOpen(false)}

                                            appId={recID}
                                            empId={EMPID}
                                        />
                                    </Box>
                                </Box>
                            </form>

                        )}
                    </Formik>

                    {/* </Box> */}
                </Paper>

            ) : (
                false
            )}
            {mode === "IM" && files.length > 0 ? (
                <Box mt={2}
                >
                    <Paper elevation={3} sx={{ padding: 2 }}>
                        {/* <Typography variant="h6" gutterBottom>
              Uploaded Files
            </Typography> */}
                        <TableContainer component={Paper} >
                            <Table size="small">
                                <TableHead>
                                    <TableRow sx={rowSx}>
                                        <TableCell width={20}><strong>SL#</strong></TableCell>
                                        <TableCell width={160}><strong>Uploaded Date</strong></TableCell>
                                        <TableCell width={250}><strong>Filename</strong></TableCell>
                                        <TableCell width={150}><strong>Purpose</strong></TableCell>
                                        <TableCell width={100}><strong>Source</strong></TableCell>
                                        <TableCell ><strong>View</strong></TableCell>


                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {files.length === 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={4} align="center">
                                                No files uploaded yet.
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        files.map((file, index) => (
                                            <TableRow key={file.id || index} sx={rowSx}>
                                                <TableCell>{index + 1}</TableCell>
                                                <TableCell>{file.uploadedDate}</TableCell>
                                                <TableCell>{file.filename}</TableCell>
                                                <TableCell>{file.purpose}</TableCell>
                                                <TableCell>{file.source}</TableCell>
                                                <TableCell>
                                                    <Tooltip title="Open File">
                                                        <IconButton
                                                            color="primary"
                                                            component="a"
                                                            href={file.url}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            size="small"
                                                        >
                                                            <OpenInNewIcon fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="delete">
                                                        <IconButton
                                                            color="error"
                                                            onClick={() => fileUpload(
                                                                file.filename,
                                                                data.EmployeeID,
                                                                "delete",
                                                                file.id,
                                                                file.purpose
                                                            )}
                                                            size="small"
                                                        >
                                                            <DeleteForeverIcon fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                </TableCell>

                                            </TableRow>
                                        ))
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </Box>
            ) : null}
        </React.Fragment>
    );
};

export default Editpermission;

